export enum MonitoringActionsE {
  HISTORY = 'history',
  PABX_WHISPER = 'pabx_whisper',
  PABX_LISTEN = 'pabx_listen',
  ATTENDANCE_OPEN = 'attendance_open',
  ATTENDANCE_TRANFER = 'attendance_transfer',
  ATTENDANCE_FINISH = 'attendance_finish',
  DISCONNECT_AGENT = 'disconnect_agent',
  START_PAUSE_ATTENDANCE = 'start_pause_attendance',
  STOP_PAUSE_ATTENDANCE = 'stop_pause_attendance',
  BLOCK_AGENT = 'block_agent',
  UNBLOCK_AGENT = 'unblock_agent',
}
